<app-dialog [(show)]="show" [enableCloseDialogButton]="!saving" [preventCloseFromBackDrop]="true" width="560px" title="Datos del paciente">
  <form #theForm="ngForm" class="ped" *ngIf="patient" (keydown.enter)="$event.preventDefault()">

    <app-patient-photo-picker
      [name]="patient.name"
      [lastName]="patient.lastName"
      [photoUrl]="patient.photoUrl"
      (photoChange)="onPhotoChange($event)"
      (croppingChange)="cropping = $event">
    </app-patient-photo-picker>

    <div class="ped-fields" [hidden]="cropping">
      <!-- Nombre: editable sólo con permiso de backoffice -->
      <ng-container *ngIf="canEditName; else readOnlyName">
        <div class="ped-pair">
          <mat-form-field appearance="outline">
            <mat-label>Nombre</mat-label>
            <input matInput name="name" required autocomplete="off" [(ngModel)]="patient.name">
            <mat-error>Completa este campo</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Apellidos</mat-label>
            <input matInput name="lastName" required autocomplete="off" [(ngModel)]="patient.lastName">
            <mat-error>Completa este campo</mat-error>
          </mat-form-field>
        </div>
      </ng-container>
      <ng-template #readOnlyName>
        <div class="ped-name">
          <span class="ped-name-label">Paciente</span>
          <span class="ped-name-value">{{ patient.name }} {{ patient.lastName }}</span>
        </div>
      </ng-template>

      <app-patient-personal-fields [(birthday)]="patient.birthday" [(gender)]="patient.gender"></app-patient-personal-fields>

      <app-patient-contact-fields [(email)]="patient.email" [(phone)]="patient.phone" [warnWhenMissing]="true"></app-patient-contact-fields>

      <p class="ped-error" *ngIf="errorMessage">{{ errorMessage }}</p>

      <div class="ped-actions">
        <button type="button" mat-button class="button info-button" (click)="close()" [disabled]="saving">Cancelar</button>
        <button type="button" mat-button class="button secondary-button" (click)="save(theForm.valid)"
                [disabled]="saving || missingContact || theForm.invalid">
          {{ saving ? 'Guardando...' : 'Guardar' }} <mat-icon *ngIf="!saving">save</mat-icon>
        </button>
      </div>
    </div>
  </form>
</app-dialog>
